<template>
  <section>
    <div v-if="isExecuting" class="row">
      <div class="col">
        <i class="fa fa-spinner fa-spin"></i>
        <span class="ms-2">{{ currentLoadingStatus }}</span>
      </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <div class="row">
          <div v-if="aiResultsThere" class="col custom-ai-results">
            <div v-html="aiResults"></div>
          </div>
          <div v-else class="col">
            <div v-html="disclaimer"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { aiStore } from '@/stores/ai'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import { JsonViewer } from 'vue3-json-viewer'
import 'vue3-json-viewer/dist/vue3-json-viewer.css'
export default {
  name: 'ai-prompt',
  components: {
    ZTabs,
    JsonViewer
  },
  props: {
    aiPrompt: {
      type: Object,
      default: null
    },
    firm: {
      type: Number,
      default: null
    },
    adasInspection: {
      type: Number,
      default: null
    },
    vehicle: {
      type: Object,
      default: null
    },
    uniqueId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isForceNew: false,
      statuses: [
        'reticulating splines...',
        'aligning flux capacitors...',
        'recalibrating quantum foam...',
        'spinning up hamster wheel...',
        'decrypting sarcasm protocol...',
        'summoning friendly AI...',
        'polishing pixels...',
        'negotiating with photons...',
        'compiling coffee...',
        'twisting spaghetti code...',
        'reanimating dead code...',
        'charging flux battery...',
        'tickling entropy...',
        'rendering low-poly reality...',
        'sanitizing unicorn horns...',
        'calibrating rubber ducks...',
        'mapping interdimensional APIs...',
        'warming up subroutines...',
        'counting backwards from infinity...',
        'folding space-time wrappers...',
        'buffering existential crisis...',
        'engaging warp noodles...',
        'feeding gremlins after midnight...',
        'compressing unicorn dreams...',
        'validating null hypothesis...',
        "hacking the mainframe (again)...",
        "disentangling spaghetti logic...",
        "compiling infinite loop...",
        "elevating debugger privileges...",
        "talking to the rubber duck...",
        "injecting caffeine into the build pipeline...",
        "optimizing banana for scale...",
        "reviving semicolon ghosts...",
        "enabling dark mode in daylight...",
        "bootstrapping the bootstrap...",
        "hunting down Schrödinger’s bug...",
        "staring meaningfully at the screen...",
        "shuffling bits for dramatic effect...",
        "untangling recursive thoughts...",
        "stabilizing metaphysical pointers..."
      ],
      currentLoadingStatus: '',
      loadingInterval: null,
      currentTab: 'Results',
      disclaimer: `<h3>OPUS IVS AI Assistants Usage Warning &amp; Disclaimer</h3>

<p>This OPUS IVS Assistants is experimental and in active development. As such, users may encounter bugs, limitations, and/or unexpected behavior. Any content, text, or otherwise, generated by these AI powered Assistants may contain inaccuracies or biases and should not be relied upon without human review and independent verification.</p>

<p>By using the OPUS IVS Assistants, users acknowledge that these AI supported systems have limitations and assume full resposibility for how its outputs are used. Critical outputs should be reviewed and verified before any decisions or actions are taken.</p>

<p>OPUS IVS disclaims all liability for errors, omissions, or losses resulting from the use of these AI Assistants.</p>
`
    }
  },
  mounted() {
    this.emitter.on('process-ai-stream', async (data) => {
      if (data !== undefined && data !== null) {
        this.aiResults = data.partial
      }
    })
  },
  computed: {
    ...mapState(aiStore, ['loading', 'aiResponse']),
    tabs() {
      let _tabs = ['Results', 'Prompt']
      return _tabs
    },
    isExecuting() {
      let _is = false
      if (this.loading) {
        _is = this.loading.aiResponse
      }
      return _is
    },
    estimate() {
      let _data = ''
      if (this.bms) {
        _data = this.bms
      }
      return _data
    },
    submittedPrompt() {
      let _data = ''
      if (this.aiResponse && this.aiResponse.prompt) {
        _data = this.aiResponse.prompt
      }
      return _data
    },
    aiResults() {
      let _data = ''
      console.log('aiResults', this.aiResponse)
      if (this.aiResponse && this.aiResponse.results) {
        _data = this.aiResponse.results
        _data = _data.replace('```html\n', '')
        _data = _data.replace('\n```\n', '')
      } else if (this.aiResponse && this.aiResponse.error) {
        _data = `<div class="alert alert-danger">${this.aiResponse.error}</div><div>${this.aiResponse.details}</div>`
      }
      return _data
    },
    aiResultsThere() {
      let _data = false
      if (this.aiResponse && (this.aiResponse.results || this.aiResponse.error)) {
        _data = true
      }
      return _data
    },
  },
  methods: {
    ...mapActions(aiStore, ['aiRequest']),
    showTab(value) {
      this.currentTab = value
    },
    startLoadingStatuses() {
      this.setRandomLoadingStatus()
      this.loadingInterval = setInterval(() => {
        this.setRandomLoadingStatus()
      }, 2000)
    },
    stopLoadingStatuses() {
      clearInterval(this.loadingInterval)
      this.loadingInterval = null
    },
    setRandomLoadingStatus() {
      const index = Math.floor(Math.random() * this.statuses.length)
      this.currentLoadingStatus = this.statuses[index]
    },
    async generateResponse() {
      await this.fetchAiResponse(false)
    },
    async fetchAiResponse(isRefresh = false) {
      console.log('fetchAiResponse', this.vehicle)
      this.startLoadingStatuses()
      try {
        await this.aiRequest({
          ai: this.aiPrompt.ai,
          firm: this.firm,
          adasInspection: this.adasInspection,
          aiName: this.aiPrompt.aiName,
          prompt: this.aiPrompt.prompt,
          aiRole: this.aiPrompt.aiRole,
          aiModel: this.aiPrompt.aiModel,
          vin: this.vehicle.vin,
          year: this.vehicle.year,
          make: this.vehicle.make,
          model: this.vehicle.model,
          AdasUUID: this.uniqueId,
          refresh: isRefresh
        })
      } finally {
        this.stopLoadingStatuses()
      }
    },
  },
  beforeUnmount() {
    this.emitter.off('process-ai-stream')
  }
}
</script>
<style scoped lang="scss">
.custom-ai-results {
  max-height: 63vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
